import {
  GreenLight100,
  LightBlue100,
  GrayWhite,
  Gray100,
  Orange100,
  Grimace100,
  WatermelonRed100,
  Yellorange100,
  PurpleRain100,
  Yellow20,
  GreenLight20,
  PurpleRain20,
  Orange20,
  LightBlue20,
  WatermelonRed20,
  Gray10,
} from '@box/blueprint-web-assets/tokens/tokens';

export const textColors = {
  gray100: Gray100,
  grayWhite: GrayWhite,
  lightBlue100: LightBlue100,
  greenLight100: GreenLight100,
  orange100: Orange100,
  grimace100: Grimace100,
  watermelonRed100: WatermelonRed100,
  yellorange100: Yellorange100,
  teal: '#119893',
  pink: '#D70382',
  darkBlue: '#0A77BA',
  purpleRain100: PurpleRain100,
} as const;

export const highlightColors = {
  grayWhite: GrayWhite, // White, but used for Clear as well until a clear icon is created
  yellow20: Yellow20,
  greenLight20: GreenLight20,
  purpleRain20: PurpleRain20,
  orange20: Orange20,
  lightBlue20: LightBlue20,
  watermelonRed20: WatermelonRed20,
  gray10: Gray10,
} as const;

export const FONT_STYLES = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'strikethrough',
} as const;

export const DEFAULT_FONT_SIZE = 12;

export const FONT_SIZES = [11, 12, 13, 14, 15, 18, 21] as const;

export const ALIGNMENT = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
} as const;

export const LIST_STYLES = {
  BULLET_LIST: 'bulletList',
  ORDERED_LIST: 'orderedList',
} as const;
